import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

export const executeGetSuggestedQuestions = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.getSuggestedQuestions.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.switchMap(([action, context]) => {
        const { data: request } = action
        if (!context) {
          // Without a context, we can't do anything
          return rxjs.of(
            feature.actions.getSuggestedQuestions.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        // We call the API (if it has the appropriate method) and return its
        // result (or throw its error)
        return (
          api.getSuggestedQuestions?.(context).pipe(
            rxjs.map(suggestedQuestions =>
              feature.actions.getSuggestedQuestions.success
                .from(action)
                .create({ request, response: { suggestedQuestions } }),
            ),
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.getSuggestedQuestions.error
                  .from(action)
                  .create({ error, request }),
              ),
            ),
          ) ??
          rxjs.of(
            feature.actions.getSuggestedQuestions.cancellation
              .from(action)
              .create({
                reason:
                  "'getSuggestedQuestions' is not implemented on this API",
                request,
              }),
          )
        )
      }),
    ),
)
